/** @jsx jsx */
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import DOMPurify from 'dompurify';
// https://www.npmjs.com/package/dompurify

import { ContentBlocTextType, ICustomTheme } from 'interfaces';

const StyledTextBloc = styled.p<{ theme: ICustomTheme }>(({ theme }) => ({
  margin: 0,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(7, 8, 2),
  '& hr': {
    backgroundColor: theme.palette.grey[600],
    border: 'none',
    height: 1,
    margin: '0 auto',
    outline: 'none',
    width: '60%',
  },
}));

const ContentBlocText = ({ text }: ContentBlocTextType): JSX.Element => {
  // ADD_ATTR needed or target="_blank" is deleted
  // rel="noopener noreferrer" is added in BO so the link is safe
  const cleanText = DOMPurify.sanitize(text, { ADD_ATTR: ['target'] });

  return (
    <StyledTextBloc dangerouslySetInnerHTML={{ __html: cleanText || '' }} /> // eslint-disable-line react/no-danger
  );
};

export default ContentBlocText;
